export default "__VITE_ASSET__BmNb_0k2__"